import { css, styled } from "goober";

export const Dialog = styled("dialog")``;

export const cssDialog = () => css`
  top: var(--title-bar-height);

  margin: auto;
  padding: 0;
  color: inherit;
  background: transparent;
  border: none;

  &::backdrop {
    inset: 0;
    top: var(--title-bar-height);

    background: var(--shade10-75);
  }

  &:not(.block-close)::backdrop {
    cursor: pointer;
  }
`;
